import React from 'react';
import { ConfirmationTemplate } from '../components/templates/ConfirmationTemplate';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

function ConfirmationPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<ConfirmationTemplate
			label={t('confirmation.label')}
			text={t('confirmation.text')}
			onHome={() => navigate('/')}
		/>
	);
}

export default ConfirmationPage;
